const colors = {
  red: '#F75E7F',
  lightBlue: '#B1F5FF',
  beige: '#F8F4E0'
};

export default colors;